import React from "react";

const AuthCard = ({ children, className = "", ...props }) => (
  <div
    className={`w-full max-w-md surface-card p-8 mx-4 sm:mx-0 ${className}`}
    {...props}
  >
    {children}
  </div>
);

export default AuthCard;
